<div class="col-12 mb-4">

  <div class="row mb-2">
    <div class="col-12">
      <small><b class="text-secondary">
        Código de vinculación
      </b></small>
    </div>
  </div>

  <div class="row">

    <div class="col d-flex align-items-center">
      {{ houseFlat?.code != '' ? houseFlat?.code : 'No asignado' }}
      @if(houseFlat?.code != '') {

        <button 
          (click)="utilService.copyToClipboard(houseFlat?.code ?? '')"
          type="button"
          class="btn">
          <i class="material-icons text-secondary">content_copy</i>
        </button>

      }
    </div>

    <div class="col-auto">
      <button
        (click)="newCode()"
        type="button"
        class="btn btn-success d-flex align-items-center justify-content-center">
        <i class="material-icons me-2">refresh</i>
        Generar nuevo código
      </button>
    </div>

  </div>
</div>